import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useDataProvider } from 'src/app/common/utils';
import { PaginateList } from 'src/app/common/types';
import { ParamsProps } from 'src/app/common/components/ParamsProvider';
import { PruTableSortTypeEnum } from 'src/app/common/components/PruTable/PruTable';
import { ContractSettingItem } from '../../../types/contract-setting-types';
import { ContractSettingListParam, fetchContractSettingList } from '../../../network/contract-setting-crud';

export type ContractSettingSortState = Record<string, PruTableSortTypeEnum | undefined>;

const initialState: ContractSettingListParam = {
  page: 1,
  limit: 5,
  productName: '',
};

export const contractSettingFilterKeys = ['productName'];

const paramsInitiator = (initialParams?: Record<string, string>): ContractSettingListParam => {
  return initialParams
    ? {
        page: 1,
        limit: 5,
        productName: initialParams.productName || '',
      }
    : initialState;
};

export const useContractSettingListingPage = ({ initialParams, onChangeQueryParams }: ParamsProps) => {
  const dispatch = useDispatch();
  const [filterState, setFilterState] = useState<ContractSettingListParam>(paramsInitiator(initialParams));
  const [contractSettingList, setContractSettingList] = useState<PaginateList<ContractSettingItem>>();

  const { isLoading, refreshData } = useDataProvider<PaginateList<ContractSettingItem>>(
    async () => {
      try {
        if (onChangeQueryParams) {
          onChangeQueryParams(filterState);
        }

        return await fetchContractSettingList(filterState, dispatch);
      } catch (err) {}
    },
    setContractSettingList,
    false,
  );

  const onSort = (newSortState: ContractSettingSortState) => {
    const sortParts = Object.entries(newSortState)
      .filter(([, direction]) => direction !== undefined)
      .map(([key, direction]) => (direction === PruTableSortTypeEnum.DESC ? `-${key}` : key));

    setFilterState((prevState) => ({
      ...prevState,
      page: 1,
      sort: sortParts.length > 0 ? sortParts.join(',') : undefined,
    }));
    refreshData();
  };

  return {
    filterState,
    contractSettingList,
    isLoading,
    setFilterState,
    refreshData,
    onSort,
  };
};
